export default __webpack_public_path__ + "static/media/office.fef950b2.jpg";